<template>
  <div class="content">
    <h1 class="font-light">Reset Password</h1>
    <div class="divider u-no-margin"></div>
    <div class="panel">
      To reset your password enter the <strong>email address</strong> that
      belongs to your account. We'll then send you an email with special codes
      to let you reset your password.
    </div>
    <div class="form-section">
      <!-- Email field -->
      <div class="row ignore-screen level">
        <div class="offset-2 col-10 error" v-if="error.email">
          {{ error.email }}
        </div>
        <div class="col-2 ignore-screen level-item font-bold">
          <span class="u-fill-width">Email:</span>
        </div>
        <div class="col-10 ignore-screen level-item input-control">
          <input
            v-model="email"
            v-bind:class="{ 'input-error': error.email }"
            class="input-contains-icon"
            type="email"
            placeholder="you@email.com"
          />
          <span class="icon">
            <i class="fa fa-wrapper fa-envelope"></i>
          </span>
        </div>
      </div>
      <space></space>
      <div class="row">
        <div class="col-12 u-text-right u-fill-width">
          <router-link
            :to="{ name: 'login' }"
            class="action-button-link u-inline"
          >
            <button class="outline action-button">
              <span class="icon">
                <i class="fa-wrapper fa fa-reply normal-icon" aria-hiden="true">
                </i>
              </span>
              <span>Login</span>
            </button>
          </router-link>
          <button
            class="btn-primary u-inline action-button"
            v-on:click="submitForm"
          >
            <loading-spinner v-show="submit"></loading-spinner>
            <i
              class="fa-wrapper fa fa-paper-plane pad-right"
              v-show="!submit"
            ></i>
            Submit
          </button>
        </div>
      </div>
    </div>
    <server-error v-bind:error="error.serverError"></server-error>
    <toast-success
      v-if="success"
      v-bind:label="'Check Your Inbox'"
      message="We've just sent you an email. Check your messages and use
               the link in that message to reset your password."
      v-on:close="closeSuccess"
    ></toast-success>
  </div>
</template>
<style>
.--tas-button-side-margin {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
</style>
<script>
import { mapGetters } from "vuex";
import * as authService from "@/services/auth.service";
import { handleError } from "@/functions/handleError.function";
import ServerError from "@/components/ServerError";
import LoadingSpinner from "@/components/LoadingSpinner";
import ToastSuccess from "@/components/ToastSuccess";

export default {
  name: "reset-password",
  components: {
    ServerError,
    LoadingSpinner,
    ToastSuccess
  },
  data: function() {
    return {
      email: "",
      submit: false,
      success: false,
      successEmail: ""
    };
  },
  computed: {
    ...mapGetters("core", ["error"])
  },
  methods: {
    validate() {
      let is_valid = true;
      if (this.email == "") {
        is_valid = false;
        let data = { email: "This field may not be blank" };
        this.$store.commit("core/setError", data);
      }
      if (!this.email.includes("@")) {
        is_valid = false;
        let data = { email: "You must enter a valid email address." };
        this.$store.commit("core/setError", data);
      }
      return is_valid;
    },
    submitForm() {
      this.$store.commit("core/clearErrors");
      this.submit = true;
      this.success = false;
      let is_valid = this.validate();
      if (!is_valid) {
        this.submit = false;
        return;
      }
      // Call the auth.service directly as this never interacts with the Vuex
      // store
      authService
        .resetPassword(this.email)
        .then(response => {
          this.submit = false;
          if (response.status == 204) {
            this.success = true;
          }
        })
        .catch(error => {
          this.submit = false;
          let data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    closeSuccess: function() {
      this.success = false;
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
  }
};
</script>
